import CommonDataStore from './CommonDataStore';
import CardDataStore from './CardDataStore';
import CategoryDataStore from './CategoryDataStore';

const store =  {
    CommonDataStore: CommonDataStore.instance,
    CardDataStore: CardDataStore.instance,
    CategoryDataStore: CategoryDataStore.instance,
};

export default store;